import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/ui/Button';
import Icon from '../../../../components/AppIcon';

const SocialRegistration = ({ onSocialRegister }) => {
    const { t } = useTranslation('common');
    const [isLoading, setIsLoading] = useState({});

    const socialProviders = [
        {
            id: 'google',
            name: 'Google',
            icon: 'google',
            color: 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
        },
        {
            id: 'facebook',
            name: 'Facebook',
            icon: 'facebook',
            color: 'bg-blue-600 text-white hover:bg-blue-700'
        },
        {
            id: 'apple',
            name: 'Apple',
            icon: 'apple',
            color: 'bg-black text-white hover:bg-gray-800'
        }
    ];

    const handleSocialLogin = async (provider) => {
        setIsLoading(prev => ({ ...prev, [provider.id]: true }));

        try {
            // Simulate social login process
            await new Promise(resolve => setTimeout(resolve, 1500));

            // In real implementation, this would handle OAuth flow
            const userData = {
                email: `user@${provider.id}.com`,
                firstName: 'John',
                lastName: 'Doe',
                avatar: `https://ui-avatars.com/api/?name=John+Doe&background=random`
            };

            onSocialRegister(provider.id, userData);
        } catch (error) {
            console.error(`${provider.name} registration failed:`, error);
            // Handle error - show toast or error message
        } finally {
            setIsLoading(prev => ({ ...prev, [provider.id]: false }));
        }
    };

    return (
        <div className="space-y-3">
            {socialProviders.map((provider) => (
                <Button
                    key={provider.id}
                    onClick={() => handleSocialLogin(provider)}
                    disabled={isLoading[provider.id]}
                    fullWidth
                    variant="outline"
                    size="lg"
                    className={`${provider.color} transition-all duration-200`}
                    loading={isLoading[provider.id]}
                >
                    <div className="flex items-center justify-center">
                        {!isLoading[provider.id] && (
                            <Icon
                                name={provider.icon}
                                className="w-5 h-5 mr-3"
                            />
                        )}
                        <span>
                            {isLoading[provider.id]
                                ? `Connecting to ${provider.name}...`
                                : `Continue with ${provider.name}`
                            }
                        </span>
                    </div>
                </Button>
            ))}
        </div>
    );
};

export default SocialRegistration; 